import type from './types';
import {
  getListTransform,
  getDetailTransform,
} from 'helpers/transformResponse';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: true,
  buttonLoading: false,
  stepLoad: false,
  coupon: {
    loading: false,
    data: null,
    error: null,
  },
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case type.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload) || INITIAL_STATE.detail,
        loading: false,
      };
    case type.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case type.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case 'CART_STEP_LOAD':
      return {
        ...state,
        stepLoad: action.payload,
      };
    case type.COUPON_APPLY_REQUEST:
      return {
        ...state,
        coupon: {
          ...state.coupon,
          loading: true,
          error: null,
        },
      };
    case type.COUPON_APPLY_SUCCESS:
      return {
        ...state,
        coupon: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case type.COUPON_APPLY_FAILURE:
      return {
        ...state,
        coupon: {
          ...state.coupon,
          loading: false,
          error: action.payload,
        },
      };
    case type.COUPON_CLEAR:
      return {
        ...state,
        coupon: { ...INITIAL_STATE.coupon },
      };
    default:
      return state;
  }
};
